import classNames from 'classnames';
import { ReactNode } from 'react';

type FlexColumnPanelProps = { className?: string; children: ReactNode };
export function FlexColumnPanel({ children, className }: FlexColumnPanelProps) {
  return <div className={classNames('d-flex flex-column overflow-y-auto h-100', className)}>{children}</div>;
}
